export const TENANTS_LIST_REQUEST = "TENANTS_LIST_REQUEST";
export const TENANTS_LIST_SUCCESS = "TENANTS_LIST_SUCCESS";

export const UNITS_LIST_REQUEST = "UNITS_LIST_REQUEST";
export const UNITS_LIST_SUCCESS = "UNITS_LIST_SUCCESS";

export const PROFITBILITY_REQUEST = "PROFITBILITY_REQUEST";
export const PROFITBILITY_SUCCESS = "PROFITBILITY_SUCCESS";
